import React from "react";
import { Button, Icon } from "semantic-ui-react";
import { formatPhoneNumberIntl } from "react-phone-number-input";

import { dialSessionNameFormatted } from "helpers/sessionHelpers";

const startCallMonitor = (campaignId, campaignTargetCallId) => {
  window.open(
    `/dialer-monitor/${campaignId}/${campaignTargetCallId}`,
    "_blank",
    "location=yes,height=750,width=1800,scrollbars=yes,status=yes"
  );
};

export const getAgentDashboardTableColumns = () => {
  return [
    {
      header: "Agent",
      id: "Agent",
      accessorKey: "agent_name",
    },
    {
      header: "Contact",
      id: "Contact",
      accessorKey: "contact_name",
    },
    {
      header: "Session",
      id: "Session",
      accessorKey: "dial_session_name",
      cell: ({ row }) =>
        dialSessionNameFormatted(row.original.dial_session_name),
    },
    {
      header: "# Calls Made",
      id: "# Calls Made",
      accessorKey: "calls_made",
    },
    {
      header: "# Live Calls",
      id: "# Live Calls",
      accessorKey: "live_calls",
    },
    {
      header: "Phone Number",
      id: "Phone Number",
      accessorKey: "number_called",
      cell: ({ row }) => formatPhoneNumberIntl(row.original.number_called),
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <Button
          compact
          color="blue"
          onClick={() =>
            startCallMonitor(
              row.original.campaign_id,
              row.original.campaign_target_call_id
            )
          }
        >
          Monitor Call
          <Icon name="phone" style={{ margin: "0 0 0 7px" }} />
        </Button>
      ),
    },
  ];
};
